import AsyncStorage from '@react-native-async-storage/async-storage'

import * as _cmCPT from './_cmCPT';

import * as ht from './_ht';
import * as hf from './_hf';

export const rmvAllAsync = () => new Promise( _exit1 => { // clear : remove all items.
  AsyncStorage.clear()
  .then( () => _exit1(true))
  .catch( () => _exit1(false))
});

export const chkAsync = () => new Promise<ht.b>( _exit1 => { // asyncstorage ( = cookie を利用可能かの確認 )
    const _key = 'CheckAsyncStorage';
    const _val = 'Enabled'
    setAsync(_key, _val)
    .then( _b => {
      if ( _b == true ) {
        getAsync(_key)
        .then( _j => {
          if ( _j == _val ) {
            rmvAsync(_key)
            .then(() => _exit1(true))
            .catch( () => _exit1(false));
          }
          else {
            _exit1(false);
          }
        });
      }
      else {
        _exit1(false);
      }
    })
    .catch( () => _exit1(false));
});

export const rmvAsync = (
  pKey: ht.s
): Promise<ht.b> => new Promise( _exit1 => { // remove
  const _key = hf.cvtHash(pKey);
  AsyncStorage.removeItem(_key)
  .then( () => _exit1(true))
  .catch( () => _exit1(false))
});

//const _srt = 'aobjfR{}buajoifek!SZ_{}SFG#'.f(icv.appName, icv.appName); // app ごとに異なる srt とする

export const getAsync = (
  pKey: ht.s,
  pSrt?: ht.s
): Promise<ht.a|null> => new Promise( _exit1 => {
  const _key = hf.cvtHash(pKey);
  AsyncStorage.getItem(_key)
  .then( (_s: ht.a) => {
    _exit1(hf.j(_cmCPT.dct(_s ?? '', pSrt)))
  })
  .catch( () => _exit1(null));
});

export const setAsync = (
  pKey: ht.s, 
  pVle: ht.a,
  pSrt?: ht.s,
): Promise<ht.b> => new Promise( _exit1 => {
  const _key = hf.cvtHash(pKey);
  const _vle = _cmCPT.ect(hf.s(pVle), pSrt);
  AsyncStorage.setItem(
    _key,
    _vle, 
  )
  .then(() => _exit1(true))
  .catch(() => _exit1(false))
});
